import moment from "moment";
import React from "react";
import { Dropdown } from "react-bootstrap";
import { BsFilePdf, BsThreeDots } from "react-icons/bs";
import { renderAttachments, renderMessage, renderReply } from "./commonMessage";
const RightSideMessage = ({
  data,
  ind,
  highlightMsg,
  setIsReplay,
  setSelectReplyData,
  handleViewProfile = () => { },
  scrollToMessage = () => { },
}) => {
  //----------handle-reply-message-------------
  const handleReply = (data) => {
    setSelectReplyData(data);
    setIsReplay(true);
  };
  // console.log('data in RightSideMessage', data)
  return (
    <div className={`unique_message_box msg-item`} key={ind}>
      <div
        className={`message-sender reply_on_msg ${highlightMsg ? "highlight-message" : ""}`}
      >
        <div className="msg-header d-flex justify-content-between">
          <span className="msg-time">{moment(data?.createdAt).fromNow()}</span>
          <div className="three-dotss">
            <Dropdown>
              <Dropdown.Toggle variant="link" id="dropdown-basic">
                <BsThreeDots />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => handleReply(data)}>
                  Reply
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        {renderReply(data, scrollToMessage)}

        <div className="msg-body">
          {renderMessage(data)}
          {renderAttachments(data, handleViewProfile)}
        </div>
      </div>
    </div>
  );
};

export default RightSideMessage;